import { PropsWithChildren, useEffect, useMemo } from 'react'
import { useRouter } from 'next/router'

import Footer from '@/components/layout/footer'
import Header from '@/components/layout/header'
import { LenisProvider } from '@/contexts/lenis'
import { useLoaderStore } from '@/store/loader'
import { useLocaleStore } from '@/store/locale'
import { useRouterStore } from '@/store/router'
import { pageHasHero } from '@/utils/page'

import { WPPageData } from '@/types'

export type LayoutProps = PropsWithChildren<{ pageProps: WPPageData }>

const Layout = ({ children, pageProps }: LayoutProps) => {
  const router = useRouter()
  const setCurrentLocale = useLocaleStore((state) => state.setCurrentLocale)
  const setCurrentRoute = useRouterStore((state) => state.setCurrentRoute)
  const setCurrentTranslations = useLocaleStore((store) => store.setCurrentTranslations)
  const setLoaderState = useLoaderStore((state) => state.setState)
  const hasHero = useMemo(() => pageHasHero(pageProps), [pageProps])

  useEffect(() => {
    if (!hasHero) {
      setLoaderState({ pageLoaded: true, loaded: true })
    }
  }, [hasHero, setLoaderState])

  useEffect(() => {
    setCurrentRoute(router.asPath)
    setCurrentLocale(router.locale)
    setCurrentTranslations(pageProps.wpml_translations || [])
  }, [
    router,
    pageProps.wpml_translations,
    setCurrentRoute,
    setCurrentLocale,
    setCurrentTranslations
  ])

  return (
    <LenisProvider>
      <div className="static">
        <Header />
        {children}
      </div>
      <Footer showInline={hasHero} />
    </LenisProvider>
  )
}

export default Layout
